'use client'

import {usePlayButton} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context'
import {useEffect} from 'react'
import {pauseAndMute} from '../game-functions'

export const useTabSwitchHandler = () => {
  const {gameScreenShown} = usePlayButton()

  useEffect(() => {
    const handleVisibilityChange = () => {
      // https://advergame.atlassian.net/browse/GAMEZ-5721
      if (!document.hidden && !gameScreenShown) {
        setTimeout(() => {
          pauseAndMute()
        }, 0)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [gameScreenShown])
}
